import axios from 'axios';
import { BACKEND_API } from "./config";

export const sendMessage = async(data) => {
    try {
        return await axios.post(`${BACKEND_API}/email_messages`, data);
    } catch (error) {
        console.log(`Api error sending a message >>> ${error.message}`, error);
    }
};